<template>
  <div ref="printHost" class="tr-print-root">
    <div
      v-show="sheetVisible"
      ref="printSheetEl"
      class="tr-print-sheet"
      aria-hidden="true"
    >
      <div
        v-for="(page, idx) in pages"
        :key="'trip-' + idx"
        class="tr-page-block"
      >
        <div class="tr-page" dir="rtl">
          <div class="tr-header">
            <div class="tr-header__logo">
              <img
                src="@/assets/logo/SSS/saptco-logo.png"
                alt="سابتكو"
                class="tr-logo"
              />
            </div>
            <div class="tr-header__company">
              الشركة السعودية للنقل الجماعي
          </div>
        </div>

          <div class="tr-header-meta">
            <span class="tr-trip-id">{{ bundle.operationId }}</span>
            <span class="tr-status-badge">قيد المعالجة</span>
          </div>

          <h1 class="tr-main-title">جدول الترحيل</h1>

          <table class="tr-table">
            <colgroup>
              <col style="width:18%" />
              <col style="width:32%" />
              <col style="width:18%" />
              <col style="width:32%" />
            </colgroup>
            <tbody>
              <tr>
                <td class="tr-lbl">نوع الرحلة</td>
                <td class="tr-val">{{ page.serviceNameAr }}</td>
                <td class="tr-lbl">اليوم</td>
                <td class="tr-val">{{ page.dayOfWeekAr }}</td>
              </tr>
              <tr>
                <td class="tr-lbl"></td>
                <td class="tr-val">- {{ page.serviceSubType }}</td>
                <td class="tr-lbl"></td>
                <td class="tr-val"></td>
              </tr>
              <tr>
                <td class="tr-lbl">تاريخ الخدمة</td>
                <td class="tr-val">{{ page.serviceDateFormatted }}</td>
                <td class="tr-lbl">تاريخ الوصول</td>
                <td class="tr-val">{{ page.arrivalDateFormatted }}</td>
              </tr>
              <tr>
                <td class="tr-lbl">اسم العميل</td>
                <td class="tr-val">{{ page.clientNameAr || '' }}</td>
                <td class="tr-lbl">الرقم</td>
                <td class="tr-val"></td>
              </tr>
              <tr>
                <td class="tr-lbl">ممثل العميل</td>
                <td class="tr-val"></td>
                <td class="tr-lbl">الرقم</td>
                <td class="tr-val"></td>
              </tr>
              <tr>
                <td class="tr-lbl">مكان الاستلام</td>
                <td class="tr-val"></td>
                <td class="tr-lbl">الاتجاه</td>
                <td class="tr-val">{{ page.directionLabel || '' }}</td>
              </tr>
            </tbody>
          </table>

          <table class="tr-table tr-table--spaced">
            <colgroup>
              <col style="width:18%" />
              <col style="width:27%" />
              <col style="width:12%" />
              <col style="width:10%" />
              <col style="width:12%" />
              <col style="width:21%" />
            </colgroup>
            <tbody>
              <tr>
                <td class="tr-lbl">اسم السائق الأول</td>
                <td class="tr-val">{{ page.driver1NameAr }}</td>
                <td class="tr-lbl">رقم السائق</td>
                <td class="tr-val">{{ page.driver1EmployeeId }}</td>
                <td class="tr-lbl">جوال السائق</td>
                <td class="tr-val">{{ page.driver1Mobile }}</td>
              </tr>
              <tr>
                <td class="tr-lbl">اسم السائق الثاني</td>
                <td class="tr-val">{{ page.driver2NameAr }}</td>
                <td class="tr-lbl">رقم السائق</td>
                <td class="tr-val">{{ page.driver2EmployeeId }}</td>
                <td class="tr-lbl">جوال السائق</td>
                <td class="tr-val">{{ page.driver2Mobile }}</td>
              </tr>
              <tr>
                <td class="tr-lbl">رقم الحافلة</td>
                <td class="tr-val">{{ page.vehicleOperationalId }}</td>
                <td class="tr-lbl">النوع</td>
                <td class="tr-val" colspan="3">{{ page.vehicleTypeName }}</td>
              </tr>
            </tbody>
          </table>

          <div class="tr-section-hdr">محطة المغادرة</div>
          <table class="tr-table">
            <colgroup>
              <col style="width:20%" />
              <col style="width:30%" />
              <col style="width:20%" />
              <col style="width:30%" />
            </colgroup>
            <tbody>
              <tr>
                <td class="tr-lbl">قراءة عدد الكيلومترات</td>
                <td class="tr-val" colspan="3"></td>
              </tr>
              <tr>
                <td class="tr-lbl">وقت المغادرة المجدول</td>
                <td class="tr-val">{{ page.scheduledDepartureTime }}</td>
                <td class="tr-lbl">وقت المغادرة الفعلي</td>
                <td class="tr-val">{{ page.actualDepartureTime }}</td>
              </tr>
              <tr>
                <td class="tr-lbl">أسم المرحل</td>
                <td class="tr-val">{{ page.officeLabel }}</td>
                <td class="tr-lbl">رقم المرحل</td>
                <td class="tr-val"></td>
              </tr>
            </tbody>
          </table>

          <div class="tr-section-hdr">نوع الخدمة</div>
          <div class="tr-service-type-row">{{ page.fullServiceLabel }}</div>

          <div class="tr-section-hdr">محطة الوصول</div>
          <table class="tr-table">
            <colgroup>
              <col style="width:20%" />
              <col style="width:30%" />
              <col style="width:20%" />
              <col style="width:30%" />
            </colgroup>
            <tbody>
              <tr>
                <td class="tr-lbl">قراءة عدد الكيلومترات</td>
                <td class="tr-val" colspan="3"></td>
              </tr>
              <tr>
                <td class="tr-lbl">وقت الوصول المجدول</td>
                <td class="tr-val">{{ page.scheduledArrivalTime }}</td>
                <td class="tr-lbl">وقت الوصول الفعلي</td>
                <td class="tr-val">{{ page.actualArrivalTime }}</td>
              </tr>
              <tr>
                <td class="tr-val tr-notes-row" colspan="4">ملاحظات المرحل</td>
              </tr>
              <tr>
                <td class="tr-lbl">أسم المرحل</td>
                <td class="tr-val"></td>
                <td class="tr-lbl">رقم المرحل</td>
                <td class="tr-val"></td>
              </tr>
            </tbody>
          </table>

          <div class="tr-footer">
            <div class="tr-footer__printed">طبع في {{ bundle.printedAtFormatted }}</div>
            <div class="tr-footer__company">الشركة السعودية للنقل الجماعي</div>
            <div class="tr-footer__line">
              الهاتف: 920026888
              &nbsp;|&nbsp;
              البريد الإلكتروني: info@saptco.com.sa
              &nbsp;|&nbsp;
              الموقع: https://www.saptco.com.sa
            </div>
            <div class="tr-footer__line">الرقم الضريبي: 300004441600003</div>
            <div class="tr-footer__line">الصفحة: {{ idx + 1 }} / {{ pages.length }}</div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HajjDawraOperationsFormPrintSheet",
  props: {
    bundle: {
      type: Object,
      default: null,
    },
  },
  data() {
    return { showSheet: false };
  },
  computed: {
    sheetVisible() {
      return !!this.bundle && this.showSheet;
    },
    pages() {
      return this.bundle?.tripPages || [];
    },
  },
  methods: {
    async downloadPdf(filename) {
      const wasShowing = this.showSheet;
      this.showSheet = true;
      await this.$nextTick();
      const el = this.$refs.printSheetEl;
      if (!el) {
        this.showSheet = wasShowing;
        return;
      }
      const id = this.bundle?.operationId || "export";
      const opt = {
        margin: [8, 8, 8, 8],
        filename: filename || `Hajj-Dawra-${id}.pdf`,
        image: { type: "jpeg", quality: 0.97 },
        html2canvas: { scale: 2, useCORS: true, logging: false },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        pagebreak: {
          mode: ["css", "legacy"],
          after: [".tr-page-block:not(:last-of-type)"],
        },
      };
      try {
        const html2pdf = (await import("html2pdf.js")).default;
        await html2pdf().set(opt).from(el).save();
      } finally {
        this.showSheet = wasShowing;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tr-print-root {
  position: static;
}
</style>

<style lang="scss">
.tr-print-sheet {
  font-family: "Tahoma", "Arial", "DejaVu Sans", sans-serif;
  font-size: 11px;
  color: #1a1a1a;
}

.tr-page-block {
  box-sizing: border-box;
  page-break-inside: avoid;
  break-inside: avoid;
}

.tr-page-block:not(:last-of-type) {
  page-break-after: always;
  break-after: page;
}

.tr-page {
  box-sizing: border-box;
  padding: 6px 0 0;
}

.tr-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 2px;
}

.tr-header__logo {
}

.tr-header__company {
  font-size: 13px;
  font-weight: 700;
  text-align: right;
  padding-top: 4px;
}

.tr-logo {
  height: 44px;
  width: auto;
}

.tr-header-meta {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-bottom: 4px;
}

.tr-trip-id {
  font-size: 14px;
  font-weight: 700;
}

.tr-status-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  background-color: #28a745;
  color: #fff;
  font-size: 10px;
  font-weight: 600;
}

.tr-main-title {
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  margin: 6px 0 8px;
}

.tr-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0;
  table-layout: fixed;
}

.tr-table td {
  border: 1px solid #999;
  padding: 4px 6px;
  vertical-align: middle;
  word-break: break-word;
  text-align: right;
}

.tr-lbl {
  background-color: #e0e0e0;
  font-weight: 600;
  font-size: 10px;
  white-space: nowrap;
}

.tr-val {
  background-color: #fff;
  min-height: 20px;
}

.tr-table--spaced {
  margin-top: 10px;
}

.tr-section-hdr {
  background-color: #c8c8c8;
  font-weight: 700;
  font-size: 11px;
  text-align: center;
  padding: 4px 6px;
  border: 1px solid #999;
  border-bottom: none;
  margin-top: 10px;
}

.tr-service-type-row {
  border: 1px solid #999;
  border-top: none;
  padding: 5px 8px;
  text-align: center;
  background: #fff;
  font-size: 11px;
}

.tr-notes-row {
  min-height: 28px;
  font-weight: 600;
  font-size: 10px;
  background-color: #f5f5f5;
}

.tr-footer {
  margin-top: 10px;
  border-top: 1px solid #888;
  padding-top: 4px;
  text-align: center;
}

.tr-footer__printed {
  text-align: right;
  font-size: 9px;
  margin-bottom: 3px;
}

.tr-footer__company {
  font-weight: 700;
  font-size: 10px;
  margin-bottom: 1px;
}

.tr-footer__line {
  font-size: 9px;
  margin-bottom: 1px;
}

@media print {
  .tr-page-block {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .tr-page-block:not(:last-of-type) {
    page-break-after: always !important;
    break-after: page !important;
  }

  @page {
    size: A4;
    margin: 12mm;
  }
}
</style>
